import {
  fetchPaymentList,
  PaymentRegisterFilterType,
} from '../../../content/applications/PaymentHistory/Services'

export const ActionTypes = {
  FETCH_PAYMENT_LIST: 'FETCH_PAYMENT_LIST',
}

export const fetchPaymentListAction = (
  startDate?: string,
  endDate?: string,
  partyId?: string,
  paymentType?: PaymentRegisterFilterType
) => ({
  type: ActionTypes.FETCH_PAYMENT_LIST,
  promise: fetchPaymentList(startDate, endDate, partyId, paymentType),
})

export const fetchPaymentListResetAction = () => ({
  type: `${ActionTypes.FETCH_PAYMENT_LIST}_RESET`,
})
